import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { KvkkDeclarationTemplate } from '../models/models'

export class GetCreditCardDeclarationTemplateApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'dealer/creditCardDeclarationTemplate',
      requesterInfo,
    })
  }

  public async getTemplate(): Promise<KvkkDeclarationTemplate> {
    return await this.getAsync<KvkkDeclarationTemplate>()
  }
}
